import { render, staticRenderFns } from "./ConfirmDeleteAccount.vue?vue&type=template&id=517785fd"
import script from "./ConfirmDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports